module.exports = __webpack_public_path__ + "static/media/Classplus-logo.0ea83767.svg";